import axios from "../http";

let module = "/outsourcing";

function exist(data) {
    return axios.get(module+"/exist/"+data.no);
}
export default {
    exist
}
